'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = typeof global !== 'undefined' && global.__MUI_SvgIcon__ || _SvgIcon2.default;

function createSvgIcon(path, displayName) {
  var Icon = function Icon(props) {
    return _react2.default.createElement(
      SvgIconCustom,
      props,
      path
    );
  };

  Icon.displayName = displayName;
  Icon = (0, _pure2.default)(Icon);
  Icon.muiName = 'SvgIcon';

  return Icon;
};

exports.default = createSvgIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/utils/createSvgIcon.js
// module id = 110
// module chunks = 35783957827783 231625713469023